import {
  CreateFmtBottleEntity,
  FmtBottleEntity,
} from '@/pages/privatePages/fmtBottle/types';
import { BaseService } from './base.service';

class FmtBottleServiceClass extends BaseService<
  'fmtBottle',
  FmtBottleEntity,
  CreateFmtBottleEntity
> {
  constructor() {
    super('fmt-bottle');
  }
}
export const fmtBottleService = new FmtBottleServiceClass();
